import { useRef } from 'react';
import { Upload } from '@huspy/briks-icons';
import { Button } from '@huspy/briks-web';
import useUploadTitleDeed from '@modules/opportunities/entities/bankApplication/mutation/useUploadTitleDeed';
import { IS_SPAIN_ENV } from '@modules/core/utils';

const UploadTitleDeed = ({
  opportunityId,
  bankApplicationExternalId,
  shouldUploadTitleDeed,
  buttonText,
}: {
  shouldUploadTitleDeed: boolean;
  opportunityId: string;
  bankApplicationExternalId: string;
  buttonText: string;
}) => {
  const { mutateAsync, isPending } = useUploadTitleDeed(opportunityId);
  const ref = useRef<HTMLInputElement | null>(null);

  if (!shouldUploadTitleDeed || IS_SPAIN_ENV) {
    return <></>;
  }

  return (
    <Button
      w='fit-content'
      variant='secondary'
      size='sm'
      onClick={ () => ref?.current?.click() }
      loading={ isPending }
    >
      <input
        ref={ ref }
        type='file'
        accept='.pdf,.jpg,.jpeg,.png'
        style={ { display: 'none' } }
        onChange={ async (event) => {
          const uploadedFile = event.target.files?.[0];
          if (uploadedFile) {
            await mutateAsync({
              bankApplicationExternalId,
              titleDeed: uploadedFile,
            });
          }
        } }
      />
      <Upload />
      {buttonText}
    </Button>
  );
};

export default UploadTitleDeed;
